import Molten from '@leverege/molten'
import Config from './Config'
import PluginSetup from './PluginSetup'

import './global-style.css'

function start( opts = { } ) {
  const cfg = Config.create()

  Molten.init( cfg )
  
  // Add plugins
  PluginSetup.install( Molten )

  Molten.create( )

}

window.Application = { start }

document.addEventListener( 'DOMContentLoaded', start )
